import { useStepperContext } from "app/contexts/stepper";
import { useInscripcionContext } from "../../inscripcion-context";
import {
  Button,
  Checkbox,
  Container,
  FormControlLabel,
  FormGroup,
  Grid,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { toast } from "react-hot-toast";
import { useState } from "react";
import { celularRegex } from "app/utils/regexps";

const initialState = {
  celular_numero: "",
  celular_principal: false,
};

function CelularForm({ celular = initialState }) {
  const { addCelular, updateCelular, deleteCelular } = useInscripcionContext();

  const [state, setState] = useState(celular);
  const [isEditable] = useState(!!celular.celular_id);
  const [isEditing, setEditing] = useState(false);

  function handleSubmit(e) {
    e.preventDefault();

    try {
      if (!!isEditable && !isEditing) {
        return setEditing(true);
      } else if (!!isEditable && !!isEditing) {
        const isUpdated = updateCelular({ celular: state });

        if (isUpdated) {
          setEditing(false);

          return toast.success("¡Número de celular actualizado!");
        }
      } else {
        const isAdded = addCelular({ celular: state });

        if (isAdded) {
          setState(celular);

          return toast.success("¡Número de celular agregado!");
        }
      }
    } catch (error) {
      console.log(error.message);

      return toast.error(error.message);
    }
  }

  function handleReset() {
    if (!!isEditable && !isEditing) {
      const isDeleted = deleteCelular({ celular_id: celular.celular_id });

      if (isDeleted) {
        return toast.success("¡Número de celular eliminado!");
      }
    } else if (!!isEditable && !!isEditing) {
      const isCanceled = window.confirm("¿Desea cancelar la edición?");

      if (isCanceled) {
        setState(celular);

        return setEditing(false);
      }
    } else {
      const isReseted = window.confirm("¿Desea reiniciar el formulario?");

      if (isReseted) {
        setState(celular);
      }
    }
  }

  return (
    <Paper
      component="form"
      className="animate__animated animate__slideInUp"
      onSubmit={handleSubmit}
      onReset={handleReset}
      variant="outlined"
    >
      <Grid container spacing={1} sx={{ padding: 2 }}>
        <Grid item xs={12}>
          <Typography variant="overline">
            <strong>{`${
              !!isEditable ? "Editar" : "Agregar"
            } número de celular`}</strong>
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <TextField
            type="text"
            label="Número de celular"
            value={state.celular_numero}
            onChange={(e) =>
              setState((state) => ({
                ...state,
                celular_numero: e.target.value,
              }))
            }
            inputProps={{
              pattern: celularRegex.pattern,
              title: celularRegex.title,
            }}
            size="small"
            fullWidth
            required
            disabled={!!isEditable && !isEditing}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <FormGroup>
            <FormControlLabel
              disabled={!!isEditable && !isEditing}
              control={
                <Checkbox
                  checked={state.celular_principal}
                  onChange={(e) =>
                    setState((state) => ({
                      ...state,
                      celular_principal: e.target.checked,
                    }))
                  }
                />
              }
              label="¿Es un número de celular principal?"
            />
          </FormGroup>
        </Grid>

        <Grid item xs={12} md={6}>
          <Stack direction="row" justifyContent="end" spacing={1}>
            <Button
              type="submit"
              variant="contained"
              size="small"
              color={!!isEditable ? "warning" : "success"}
            >
              {!!isEditable && !isEditing
                ? "Editar"
                : !!isEditing
                ? "Actualizar"
                : "Agregar"}
            </Button>

            <Button
              type="reset"
              variant="outlined"
              size="small"
              color={!!isEditable && !isEditing ? "error" : "inherit"}
            >
              {!!isEditable && !isEditing
                ? "Eliminar"
                : !!isEditing
                ? "Cancelar"
                : "Reiniciar"}
            </Button>
          </Stack>
        </Grid>
      </Grid>
    </Paper>
  );
}

export function Celulares() {
  const stepper = useStepperContext();
  const { empresa } = useInscripcionContext();

  function handleNext() {
    try {
      if (!empresa.celulares.length) {
        throw new Error("¡Por favor, agregue al menos un número de celular!");
      }

      return stepper.next();
    } catch (error) {
      return toast.error(error.message);
    }
  }

  return (
    <Stack spacing={2}>
      <Container maxWidth="sm">
        <Stack spacing={2}>
          {empresa.celulares.map((celular) => (
            <CelularForm key={celular.celular_id} celular={celular} />
          ))}

          <CelularForm />
        </Stack>
      </Container>

      <Stack
        direction="row"
        justifyContent="end"
        alignItems="center"
        spacing={1}
      >
        {!stepper.isFirstStep && (
          <Button variant="outlined" size="small" onClick={stepper.back}>
            Atrás
          </Button>
        )}

        <Button variant="contained" size="small" onClick={handleNext}>
          Siguiente
        </Button>
      </Stack>
    </Stack>
  );
}
